import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AdminImportRequestItemShow } from './useFetchAdminImportRequestItemShow';

export type CreateAdminImportRequestItemParams = {
  importRequestId: number;
  outer_job_post: {
    title: string;
    url: string;
    company_name?: string;
    job_content?: Array<{ key?: string; label?: string; content?: string }>;
    agent_content?: Array<{ key?: string; label?: string; content?: string }>;
  };
};

export default function usePostAdminImportRequestItemCreate() {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement | undefined)
    ?.content;

  return useMutation({
    mutationFn: async (params: CreateAdminImportRequestItemParams) => {
      const response = await fetch(`/admin/api/import_requests/${params.importRequestId}/items`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token || '',
        },
        body: JSON.stringify({
          outer_job_post: params.outer_job_post,
        }),
      });
      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        const msg = (body as { error?: string }).error ?? '求人の追加に失敗しました';
        throw new Error(msg);
      }
      return (await response.json()) as AdminImportRequestItemShow;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['admin', 'import_requests', variables.importRequestId, 'items'],
      });
    },
  });
}
